import React, {Component} from 'react';
import './Blog.css';

class Blog extends Component {
    state = {  }
    render() {
        return (
            <div className="divBlogStyle">
                <div className="divAboutMeHeader" >
                   <h1>Blog</h1>
                   <hr className="solid"></hr>
                </div>
                <article className="blog-card">
                    <p className="blog-card-eyebrow">Medium article</p>
                    <h2>How AI Can Improve Cold Storage Warehouse Automation</h2>
                    <p className="blog-summary">
                    AI should not replace warehouse automation systems. It should help backend systems make smarter operational decisions.
                    </p>
                    <div className="blog-content-grid">
                        <div>
                            <h3>In the article, I discussed:</h3>
                            <ul>
                                <li>Predictive maintenance</li>
                                <li>Smarter pallet routing</li>
                                <li>Energy optimization</li>
                                <li>Computer vision for receiving accuracy</li>
                                <li>Forecasting and intelligent slotting</li>
                            </ul>
                        </div>
                        <div>
                            <h3>My key takeaway:</h3>
                            <p className="blog-takeaway">
                            AI recommends.<br/>
                            Backend validates.<br/>
                            Automation executes.<br/>
                            Operators supervise.<br/>
                            The system learns.
                            </p>
                        </div>
                    </div>
                    <p className="blog-summary">
                    For real-world automation environments, the hard part is not only building AI models. It is safely integrating AI into backend workflows, IoT events, WMS/WCS systems, and exception handling.
                    </p>
                    <div className="blog-tags" aria-label="Topics covered by blog">
                        <span>#ArtificialIntelligence</span>
                        <span>#WarehouseAutomation</span>
                        <span>#SupplyChain</span>
                        <span>#Logistics</span>
                        <span>#IoT</span>
                        <span>#BackendEngineering</span>
                    </div>
                    <a
                        className="blog-link"
                        href="https://medium.com/@ankitlalwani30/from-automation-to-intelligence-in-temperature-controlled-warehouses-73e6a2643074"
                        target="_blank"
                        rel="noopener noreferrer">
                        Read on Medium
                    </a>
                </article>
                <article className="blog-card">
                    <p className="blog-card-eyebrow">Medium article</p>
                    <h2>The Backend Architecture Behind AI-Enabled Warehouse Automation</h2>
                    <p className="blog-summary">
                    AI in warehouse automation is not only a model-design problem. It is also a backend architecture problem.
                    </p>
                    <div className="blog-content-grid">
                        <div>
                            <h3>Before an AI recommendation influences real-world execution, the system needs:</h3>
                            <ul>
                                <li>Validation</li>
                                <li>State checks</li>
                                <li>Fallback workflows</li>
                                <li>Operator control</li>
                                <li>Auditability</li>
                            </ul>
                        </div>
                        <div>
                            <h3>The bigger architecture question:</h3>
                            <p className="blog-takeaway">
                            How should AI recommendations move safely from model output to warehouse execution?
                            </p>
                        </div>
                    </div>
                    <p className="blog-summary">
                    That becomes especially important when software decisions interact with physical systems like conveyors, scanners, sensors, pallets, and warehouse workflows. In this article, I explored what it takes to move AI from an isolated prediction layer into real automation workflows.
                    </p>
                    <p className="blog-summary">
                    For me, the answer is not about letting AI directly control everything. It is about designing a controlled decisioning flow where AI can suggest better actions, backend systems can verify those actions, operators can stay in control, and outcomes can be captured for continuous improvement.
                    </p>
                    <p className="blog-summary">
                    Each layer has a different responsibility. AI can improve decision quality, but backend systems still need to protect operational state, enforce constraints, and ensure that execution remains safe, traceable, and practical on the warehouse floor.
                    </p>
                    <div className="blog-tags" aria-label="Topics covered by blog">
                        <span>#ArtificialIntelligence</span>
                        <span>#WarehouseAutomation</span>
                        <span>#BackendEngineering</span>
                        <span>#SystemDesign</span>
                        <span>#IoT</span>
                        <span>#Automation</span>
                    </div>
                    <a
                        className="blog-link"
                        href="https://medium.com/@ankitlalwani30/the-backend-architecture-behind-ai-enabled-warehouse-automation-f75226a00a94"
                        target="_blank"
                        rel="noopener noreferrer">
                        Read on Medium
                    </a>
                </article>
            </div>
        );
    }
}
 
export default Blog;
